// Dedicated downward-cut sprites. Source pixels; reference sheet and boot measurements:
// docs/handoffs/assets/2026-09-12-fajin-redraw/registration.json.
// Use the feet for horizontal placement so raising the blade does not move the whole body.
export const FAJIN_DOWNCUT_ART: Record<string, { scale: number; footX: number }> = {
  fajin_lift: { scale: 1.26, footX: 516 },
  fajin_high: { scale: 1.12, footX: 500 },
  fajin_fall: { scale: 1.40, footX: 630 },
  fajin_cut: { scale: 1.15, footX: 976 },
  fajin_finish: { scale: 1.15, footX: 963 },
  fajin_return: { scale: 1.14, footX: 694 },
}
